"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MineralDeposit = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Options_1 = require("../Options");
var MineralDeposit = (function (_super) {
    __extends(MineralDeposit, _super);
    function MineralDeposit() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.MINERAL_DEPOSIT,
            cost: 5,
            metadata: {
                cardNumber: '062',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.steel(5, { digit: Options_1.digit }); }),
                description: 'Gain 5 steel.',
            },
        }) || this;
    }
    MineralDeposit.prototype.play = function (player) {
        player.steel += 5;
        return undefined;
    };
    return MineralDeposit;
}(Card_1.Card));
exports.MineralDeposit = MineralDeposit;
